import React, { Component, PropTypes } from 'react';
import { Link, browserHistory, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { verifyEmail } from 'common/ducks/user';
import { LoadingIndicator } from 'common/components/preloader';
import { Meta } from 'common/components/meta';

class VerifyEmail extends Component {
  componentDidMount() {
    const { verifyEmail, base64String, hexString, registering, emailVerified } = this.props;

    if (emailVerified) {
      if (registering) {
        /* continue registration if that's the case */
        browserHistory.push('/register/continue/');
      }
    } else {
      verifyEmail(base64String, hexString, registering);
    }
  }

  render() {
    const { emailVerified } = this.props

    return (
      <div className="l-content info-screen" id="content">
        <Meta title="Verify your email" />
        {emailVerified === undefined?
        <LoadingIndicator/>:
        <div className="row">
          <div className="columns medium-8 small-16">

            <h2>{emailVerified? 'Email Verified':'Email Verification Failed'}</h2>

            {emailVerified?
            <p>
              Thanks for verifying your email. We take the protection of your identity
              and personal information seriously.
              To learn more about how we protect your privacy, visit our <Link to="/help/">
              help center</Link>.
            </p>:
            <p>
              We take the protection of your identity and personal information seriously.
              To learn more about how we protect your privacy, visit our <Link to="/help/">
              help center</Link>. Please contact contact customer service to fix this.
            </p>}

            {emailVerified?
            <Link to="/account/info/" className="btn btn-tertiary">Go to My Account</Link>:
            <Link className="btn btn-tertiary" to="/help/contact/">Get in touch</Link>}

          </div>

          <div className="columns medium-8 small-16 icon hide-for-small-only">
            <i className={"fa fa-" + (emailVerified? "check-circle":"frown-o")}></i>
          </div>
        </div>}

      </div>
    );
  }
}

VerifyEmail.propTypes = {
  base64String: PropTypes.string,
  hexString: PropTypes.string,
  registering: PropTypes.bool,
  emailVerified: PropTypes.bool,
};

function mapStateToProps(state, { params, location: { query } }) {
  const user = state.user.profile_data;

  return {
    base64String: params.verifyString,
    hexString: params.hexString,
    registering: query && query.registration == 'true',
    emailVerified: user.is_email_validated? true : state.user.emailVerified,
  };
}

export default withRouter(connect(mapStateToProps, { verifyEmail })(VerifyEmail));



// WEBPACK FOOTER //
// ./common/components/verify_email.jsx